import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from '@angular/material/dialog';
import { Users } from 'app/_models/users';
import { AdminService } from 'app/_services/admin.service';
import { EditUserComponent } from './edit-user/edit-user.component';
import { Router } from '@angular/router';
import { AccountLockReq, AccountUnLockReq, UserModel } from 'app/_models/user-model';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { AccountService } from 'app/_services/account.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';

declare const swal: any;

@Component({
  selector: "user-management",
  templateUrl: "./user-management.component.html",
})
export class UserManagementComponent implements OnInit, AfterViewInit {
  users: Users[];
  displayedColumns: string[] = [
    "icon",
    "employeeId",
    "firstName",
    "phoneNumber",
    "email",
    "roleName",
    "appuserStatus",
    "reset",
    "action",
    "isLocked",
  ];
  dataSource = new MatTableDataSource<Users>([]);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  editUserDetail: Users;
  isLoaderResult = true;
  resultLength = 0;
  currentUser: UserModel;
  isAdmin: boolean = false;
  isSuperAdmin: boolean = false;

  constructor(
    public datepipe: DatePipe,
    private readonly adminService: AdminService,
    private readonly accountService: AccountService,
    private readonly matDialog: MatDialog,
    private readonly router: Router,
    private readonly _liveAnnouncer: LiveAnnouncer
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));

    let roles = this.currentUser.roles;
    if (roles.length > 0) {
      roles = roles.map(function (x) {
        return x.toUpperCase();
      });
      if (roles.includes("SUPERADMIN")) {
        this.isSuperAdmin = true;
      }
    }
  }

  ngOnInit() {
    this.isLoaderResult = true;
    this.getUsers();
  }

  AddUser() {
    this.router.navigateByUrl("add-user");
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getUsers() {
    this.adminService.getUsers().subscribe((response) => {
      this.users = response;
      this.dataSource = new MatTableDataSource<Users>(this.users);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.resultLength = this.users.length;
      this.isLoaderResult = false;
    });
  }

  editUser(e, element) {
    let editUser = element;
    e.stopPropagation();
    const dialogRef = this.matDialog.open(EditUserComponent, {
      width: "850px",
      disableClose: true,
      data: editUser,
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getUsers();
    });
  }

  resetPassword(e, element) {
    this.isLoaderResult = true;
    let editUser = element;
    e.stopPropagation();

    swal({
      title: "",
      html:
        "Are you sure to reset the password of " +
        editUser.email +
        " ?<br><strong> You won't be able to revert this!</strong>",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Reset Password!",
    })
      .then((result) => {
        if (result) {
          // User clicked "Yes"
          let model = {
            userEmail: editUser.email,
            requestedBy: this.currentUser.userId,
          };
          this.accountService.resetPassword(model).subscribe(
            (data) => {
              if (data.didError) {
                swal({
                  title: data.message,
                  text: data.additionalMessage,
                  type: "error",
                  confirmButtonClass: "btn btn-info",
                });
              } else {
                swal({
                  title: "",
                  text: data.message,
                  type: "success",
                  confirmButtonClass: "btn btn-info",
                });
              }
              this.isLoaderResult = false;
            },
            (error) => {
              const errorMessage =
                error.error?.title ||
                error.error ||
                "Something went wrong. Please contact admin.";
              swal({
                title: "",
                text: errorMessage,
                type: "error",
                confirmButtonClass: "btn btn-info",
              });
              this.isLoaderResult = false;
            }
          );
        } else {
          this.isLoaderResult = false;
        }
      })
      .catch((dismiss) => {
        // Arrow function preserves 'this' context
        if (dismiss === "cancel") {
          this.isLoaderResult = false;
          swal({
            title: "Cancelled",
            text: "The password reset operation was cancelled.",
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      });
  }

  exportExcel() {
    //employeeId", "", "", "", "roleName", "appuserStatus"
    const workSheet = XLSX.utils.json_to_sheet(
      this.dataSource.data.map((item) => {
        return {
          EmployeeId: item.employeeId,
          FirstName: item.firstName,
          LastName: item.lastName,
          Mobile: item.phoneNumber,
          email: item.email,
          Role: item.roleName,
          UserStatus: item.appuserStatus,
        };
      })
    );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
    let fileName =
      "Users_" +
      this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
      ".xlsx";
    XLSX.writeFile(workBook, fileName);
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  lockUnlockUser(e, element) {
    this.isLoaderResult = true;
    let loggedinUser = this.currentUser.username;
    let editUser = element;
    e.stopPropagation();
    let lockStatus = editUser.isLocked;

    let confirmMessageStatus = lockStatus
      ? `Are you sure to unlock the user <span style="color: blue; font-size: 18px; font-weight: bold;">${editUser.email}</span>?`
      : `Are you sure to lock the user <span style="color: blue; font-size: 18px; font-weight: bold;">${editUser.email}</span>?`;

    confirmMessageStatus +=
      "<br><strong style='color: red; font-size: 16px;'>You won't be able to revert this!</strong>"; // Add styling to the warning message

    swal({
      title: "",
      html:
        confirmMessageStatus +
        '<input id="swal-input" class="swal2-input" placeholder="Enter your remarks">' +
        '<p id="error-message" style="color: red; display: none;">Please enter some remarks.</p>' + // Add hidden error message
        '<p id="length-message" style="color: red; display: none;">Please enter max. 100 characters as remarks.</p>',
      showCancelButton: true,
      confirmButtonText: "OK",
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          let inputValue = (
            document.getElementById("swal-input") as HTMLInputElement
          ).value.trim(); // Cast to HTMLInputElement
          if (inputValue.length === 0) {
            document.getElementById("error-message").style.display = "block"; // Show error message
            reject(new Error("Remarks are required")); // Prevent closing the modal
          } else if (inputValue.length > 100) {
            document.getElementById("length-message").style.display = "block"; // Show length error message
            reject(new Error("Remarks too long")); // Prevent closing the modal
          } else {
            resolve(inputValue); // Proceed if input is valid
          }
        });
      },
      allowOutsideClick: false,
    })
      .then((result) => {
        if (result) {
          if (lockStatus) {
            // calling unlock method
            let model = {
              userEmail: editUser.email,
              unLockedBy: loggedinUser,
              unLockingRemarks: result,
            };
            this.callUnLockService(model); // Now 'this' correctly refers to the class
          } else {
            // calling lock service
            let model = {
              email: editUser.email,
              lockType: "AdminAction",
              isLockedDueToInactivity: false,
              lockedBy: loggedinUser,
              lockingRemarks: result,
            };
            this.callLockService(model); // Now 'this' correctly refers to the class
          }
        }
      })
      .catch((dismiss) => {
        // Arrow function preserves 'this' context
        if (dismiss === "cancel") {
          this.isLoaderResult = false;
          swal({
            title: "Cancelled",
            text: "Account Lock/Unlock operation was cancelled.",
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      });
  }

  callLockService(model: AccountLockReq) {
    this.accountService.accountLockRequest(model).subscribe(
      (data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          this.isLoaderResult = false;
          this.getUsers();
        }
      },
      (error) => {
        const errorMessage =
          error.error?.title ||
          error.error ||
          "Something went wrong. Please contact admin.";
        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }

  callUnLockService(model: AccountUnLockReq) {
    this.accountService.accountUnLockRequest(model).subscribe(
      (data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          this.isLoaderResult = false;
          this.getUsers();
        }
      },
      (error) => {
        const errorMessage =
          error.error?.title ||
          error.error ||
          "Something went wrong. Please contact admin.";
        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }

  applyFilter(filterValue: string) {
   this.dataSource.filter = filterValue;
  }
}
 